import { render, staticRenderFns } from "./ToolbarBox.vue?vue&type=template&id=5cc7069e&scoped=true&"
import script from "./ToolbarBox.vue?vue&type=script&lang=js&"
export * from "./ToolbarBox.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarBox.vue?vue&type=style&index=0&id=5cc7069e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7069e",
  null
  
)

export default component.exports